module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-123.250c5272.jpg";